import React from 'react';
import { Spinner, Center, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ClientesForm from '../../../components/forms/ClientesForm';
import { FormularioDeCliente } from '../../permissoes/CabecalhoCentral';
import { api } from '../../../services/api';

// Interface de resposta do endpoint GET /secao-cliente/{id}/
interface IClienteResponse {
  data: {
    id: number;
    guid: string;
    nome: string;
    email: string;
    cpf: string | null;
    ativo: boolean;
    empresas: Array<{
      id: number;
      razao_social: string;
      nome_fantasia: string;
      cnpj: string;
      validado: boolean;
    }>;
  };
  message: string;
}

// Função para buscar cliente da seção cliente
const getCliente = async (clienteId: number): Promise<IClienteResponse> => {
  const res = await api.get<IClienteResponse>(`/api/v1/secao-cliente/${clienteId}/`);
  return res.data;
};

export default function ClientesEditPage() {
  const { itemId } = useParams<{ itemId: string }>();

  const { data, isLoading, isError } = useQuery<IClienteResponse>({
    queryKey: ['secao-cliente', itemId],
    queryFn: () => getCliente(Number(itemId)),
    enabled: !!itemId,
  });

  const cliente = data?.data;

  if (isLoading) {
    return (
      <Center h="400px">
        <Spinner size="xl" color="primary" />
      </Center>
    );
  }

  if (isError || !cliente) {
    return (
      <Center h="400px">
        <Text color="red.500">Erro ao carregar dados do cliente.</Text>
      </Center>
    );
  }

  return (
    <FormularioDeCliente>
      <ClientesForm
        defaultValues={{
          id: cliente.id,
          nome: cliente.nome,
          email: cliente.email,
          ativo: cliente.ativo,
          empresas_ids: cliente.empresas.map(emp => emp.id),
        }}
      />
    </FormularioDeCliente>
  );
}
